
import ReactECharts from 'echarts-for-react';

const SpiChart = ({ data, compact = false, chartTitle }) => {
  data = data.sort((a, b) => new Date(a.date) - new Date(b.date))
  var barWidth = compact ? 12 : 22;
  const getOption = () => {
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['Extremely dry', 'Severely dry', 'Moderately dry', 'Near Normal Conditions', 'Moderately wet', 'Very wet', 'Extremely wet'],
        ...(compact
          ? { type: 'scroll', textStyle: { fontSize: 10 }, itemWidth: 12, itemHeight: 10, itemGap: 6 }
          : { align: 'left' }),
        bottom: 0
      },
      grid: {
        left: '15%',
        right: '15%',
        bottom: compact ? '18%' : '10%',
        containLabel: true,
        show: false
      },
      xAxis: {
        type: 'category',
        data: data.map(item => item.date),
        axisTick: {
          alignWithLabel: true
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: true
        }
      },
      yAxis: {
        type: 'value',
        name: '% Whole Region',
        nameLocation: 'middle',
        nameGap: 20,
        nameTextStyle: {
          padding: [0, 0, 20, 0]
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: true
        },
        splitLine: {
          show: true
        }
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: {
            show: true,
            title: 'Download',
            name: chartTitle || 'SPI Chart',
            pixelRatio: 2
          }
        },
        right: 20
      },
      series: [
        {
          name: 'Extremely dry',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth, // Adjust the bar width as needed
          data: data.map(item => item['Extremely dry']),
          itemStyle: {
            color: 'red'
          }
        },
        {
          name: 'Severely dry',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Severely dry']),
          itemStyle: {
            color: '#FFA129'
          }

          
        },
       
        {
          name: 'Moderately dry',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Moderately dry']),
          itemStyle: {
            color: '#FEFF37'
          },
        },

        {
          name: 'Near Normal Conditions',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Near Normal Conditions']),
          itemStyle: {
            color: '#F5F5F5'
          },
        },

        {
          name: 'Moderately wet',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Moderately wet']),
          itemStyle: {
            color: '#E8C4F6'
          },
        },
        {
          name: 'Very wet',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Very wet']),
          itemStyle: {
            color: '#AB45B8'
          },
        },

        {
          name: 'Extremely wet',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Extremely wet']),
          itemStyle: {
            color: '#AB45B8'
          },
        },
      ],
      barCategoryGap: '1%',
      barGap: '-1px',

    };
  };

  return <ReactECharts option={getOption()} style={{ height: compact ? '240px' : '300px', width: '100%' }} />;
};

export default SpiChart;
